// import restrictedCountryCodes from "../config/restrictedCountries";
import unrestrictedCountries from "../config/unrestrictedCountries";

/**
 * A functionality to check if the country is restricted?
 *
 *
 *
 *
 * @param {string} isoCode Country ISO Code
 * @returns {boolean}
 */
const isCountryRestricted = (isoCode) => {
  // const restricedISOs = Object.values(restrictedCountryCodes);
  const restricedISOs = Object.keys(unrestrictedCountries);
  if (!restricedISOs.includes(isoCode)) return true;
  else return false;
};

export default isCountryRestricted;
